import script from "./LatexStylePanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./LatexStylePanel.vue?vue&type=script&lang=ts&setup=true"

import "./LatexStylePanel.vue?vue&type=style&index=0&id=d7bfb440&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7bfb440"]])

export default __exports__